"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Offers = void 0;
var Offers_container_1 = require("./Offers.container");
Object.defineProperty(exports, "Offers", { enumerable: true, get: function () { return Offers_container_1.OffersContainer; } });
